import { render, staticRenderFns } from "./CampaignGroup.vue?vue&type=template&id=79563c36"
import script from "./CampaignGroup.vue?vue&type=script&lang=js"
export * from "./CampaignGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports